import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation } from 'react-query';
import { Video } from './guidesQuery';
import { useTranslation } from 'react-i18next';

type PrepareVideosResponse = {
  videos: Video[];
};

const prepareVideos = async ({ videoIds }: { videoIds: number[] }) => {
  return (
    await EXPRESS_API.post(`guides/prepare`, {
      videoIds,
    })
  ).data;
};

export const usePrepareVideos = () => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(prepareVideos, {
    onError: err => showError(err),
    onSuccess: (res: PrepareVideosResponse) => {
      successToast({
        title: t(`You have successfully prepared video!`, {
          count: res.videos.length,
        }),
      });
    },
  });
};
